import React, { useState } from "react";
import OrderBook from "./OrderBook";
import PriceChart from "./PriceChart";
import "./OrderBookCard.css";

function computePosition(fills) {
  let netQty = 0;
  let buyQty = 0, buyValue = 0;
  let sellQty = 0, sellValue = 0;
  for (const fill of fills) {
    const qty = fill.quantity || 0;
    const price = fill.price || 0;
    if (fill.side === "buy") {
      netQty += qty;
      buyQty += qty;
      buyValue += qty * price;
    } else {
      netQty -= qty;
      sellQty += qty;
      sellValue += qty * price;
    }
  }
  // Use avg price of the dominant-direction fills
  let avgPrice = null;
  if (netQty > 0 && buyQty > 0) avgPrice = buyValue / buyQty;
  else if (netQty < 0 && sellQty > 0) avgPrice = sellValue / sellQty;
  return { netQty, avgPrice };
}

function OrderBookCard({ symbol, marketData, priceHistory, userOrders, fills = [], isSelected, onSelect }) {
  const [showChart, setShowChart] = useState(false);
  const midPrice = marketData?.mid_price;
  const { netQty, avgPrice } = computePosition(fills);

  return (
    <div
      className={`order-book-card${isSelected ? " selected" : ""}`}
      onClick={() => onSelect(symbol)}
    >
      <div className="order-book-card-header">
        <span className="order-book-card-symbol">{symbol}</span>
        {midPrice != null && midPrice > 0 ? (
          <span className="order-book-card-mid">${Number(midPrice).toFixed(2)}</span>
        ) : (
          <span className="order-book-card-mid no-data">—</span>
        )}
        {netQty !== 0 && avgPrice != null && (
          <span className={`order-book-card-position ${netQty > 0 ? "long" : "short"}`}>
            {netQty > 0 ? "+" : ""}{netQty} @ ${Number(avgPrice).toFixed(0)}
          </span>
        )}
        <button
          className={`order-book-chart-toggle${showChart ? " active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            setShowChart((prev) => !prev);
          }}
          title="Toggle price chart"
        >
          📊
        </button>
      </div>
      {showChart && (
        <div className="mini-chart-wrapper">
          <PriceChart
            priceHistory={priceHistory}
            symbol={symbol}
            mode="single"
            height={200}
            compact
          />
        </div>
      )}
      <OrderBook
        marketData={marketData}
        symbol={symbol}
        userOrders={userOrders}
      />
    </div>
  );
}

export default OrderBookCard;
